var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4956 6.75V10.75C2.49565 11.1247 2.41154 11.4947 2.24948 11.8326C2.08742 12.1704 1.85154 12.4675 1.55928 12.702L1.25016 12.9501C-0.220352 14.1303 0.616629 16.5 2.4996 16.5H16.0036C17.8866 16.5 18.7236 14.1304 17.2531 12.9501L16.9444 12.7024C16.3524 12.2264 16.0076 11.5081 16.0076 10.75V6.75C16.0072 5.86318 15.832 4.98476 15.4923 4.16562C15.1525 3.34648 14.6547 2.60228 14.0273 1.97552C13.3999 1.34876 12.6552 0.851711 11.8357 0.512751C11.0164 0.173838 10.1379 -0.000392704 9.25123 6.64606e-07C5.52092 0.000203641 2.4956 3.02118 2.4956 6.75ZM9.25198 1.5C9.94181 1.49966 10.625 1.63519 11.2624 1.89886C11.8999 2.16253 12.4791 2.54917 12.9672 3.03671C13.4552 3.52425 13.8424 4.10315 14.1067 4.74034C14.371 5.37753 14.5073 6.06054 14.5076 6.75038V10.75C14.5076 11.9638 15.0594 13.1119 16.0052 13.8719L16.3142 14.1199C16.6776 14.4117 16.4726 15 16.0036 15H2.4996C2.03058 15 1.82558 14.4117 2.18906 14.1199L2.49805 13.8719C2.96548 13.4969 3.34272 13.0217 3.60192 12.4813C3.86113 11.941 3.99566 11.3492 3.9956 10.7499V8.3631V6.75C3.9956 4.19358 5.82516 2.06337 8.24854 1.59554C8.57334 1.53284 8.90881 1.5 9.25198 1.5Z",
    fill: "#D8DFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75159 18C7.33737 18 7.00159 18.3358 7.00159 18.75C7.00159 19.1642 7.33737 19.5 7.75159 19.5H10.7516C11.1658 19.5 11.5016 19.1642 11.5016 18.75C11.5016 18.3358 11.1658 18 10.7516 18H7.75159Z",
    fill: "#D8DFEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutline);
export default __webpack_public_path__ + "static/media/bell-outline.d699c9a13f1295489445ee6d0ca1a625.svg";
export { ForwardRef as ReactComponent };